var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "syf-component-library/ui/spacing";
import { DashedLine, VantageBody, VantageImage, VantagePageWrapper, VantageTitle, } from "./subcomponents";
import { useConfig } from "../hooks/useConfig";
import CrossBorderModal from "../ui/atoms/CrossBorderModal";
import VantageTrans from "../ui/atoms/VantageTrans";
var VantageLayout = function (_a) {
    var children = _a.children, headeri18nKey = _a.headeri18nKey;
    var config = useConfig();
    return (_jsxs(VantagePageWrapper, { children: [_jsx("div", { children: _jsx(VantageImage, { src: "".concat(config.hosts.assets, "/assets/vantage/credit-score-meter.PNG"), alt: "credit-score-meter", "data-test": "credit-score-img" }) }), _jsxs(VantageBody, { children: [_jsx(Stack, { size: "xxlarge" }), _jsx(VantageTitle, __assign({ as: "h1", weight: "bold" }, { children: _jsx(VantageTrans, { i18nKey: headeri18nKey }) })), _jsx(Stack, { size: "xxlarge" }), _jsx(DashedLine, {}), _jsx(Stack, { size: "xlarge" }), children] }), _jsx(CrossBorderModal, {})] }));
};
export default VantageLayout;
